var map = {
	"./budget.jpg": 6131,
	"./coding-quiz.jpg": 759,
	"./fff.jpg": 5609,
	"./pet-project.jpg": 8472,
	"./qrad.jpg": 6745,
	"./taskmaster.jpg": 9388,
	"./weather.jpg": 3040
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6344;